require('/opt/odin/app/frontend/components/preparation_guide/index.module.scss');module.exports = "../../app/cells/components/preparation_guide/show.erb";